// T3/100A06: registro de errores no controlados (eventos y promesas sin catch). No cambia el
// comportamiento: solo deja en consola qué falló y en qué pantalla, en lenguaje claro.
let registered = false;

export const describeError = (reason) =>
  reason?.response?.data?.message || reason?.response?.data?.error?.message || reason?.message || String(reason);

export const registerGlobalErrorHandlers = (target = window) => {
  if (registered || !target?.addEventListener) return false;
  registered = true;
  target.addEventListener("error", (event) => {
    console.error(`[APP] Error no controlado en ${target.location?.pathname}:`, event?.error || event?.message);
  });
  target.addEventListener("unhandledrejection", (event) => {
    console.error(`[APP] Promesa sin manejar en ${target.location?.pathname}:`, describeError(event?.reason), event?.reason);
  });
  return true;
};
